// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import {sendSubmissionEmail} from 'backend/email';

$w.onReady(function () {
	//TODO: write your page related code here...
	$w('#datasetGeneralSubmissions').onAfterSave(executeGeneralSubmissionEmail);
});

function executeGeneralSubmissionEmail () {
	const form_name = `טופס כללי`;
	const body = `הגשה של טופס כללי\r\r
				\rשם הארגון: ${$w('#generalOrgName').value}
				\rשם איש הקשר: ${$w('#generalContactPerson').value}
				\rטלפון ישיר: ${$w('#generalPhone').value}
				\rאימייל ישיר: ${$w('#generalEmail').value}
				\rנתונים נוספים: ${$w('#generalMoreInfo').value}`;

	sendSubmissionEmail(form_name, body)
	.then(response => {console.log(response)});
}